import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast, Toaster } from "sonner";

export default function AdminLogin() {
  const { user, ready, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const loc = useLocation();

  if (ready && user && user.role === "admin") {
    return <Navigate to={loc.state?.from || "/admin"} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") {
        setError("Account is not an admin");
        return;
      }
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, "Invalid credentials"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-6" data-testid="admin-login-page">
      <Toaster position="top-center" richColors />
      <div className="max-w-sm w-full">
        <img
          src="https://customer-assets-cm19k8pv.emergentagent.net/job_goa-art-space/artifacts/47po7jix_final%20logo%20no%20background%20.png"
          alt="Carpe Diem Goa"
          className="h-20 w-auto object-contain -ml-1 mb-6"
        />
        <div className="overline">Admin</div>
        <h1 className="display text-4xl mt-3">Sign in.</h1>
        <p className="text-muted2 text-sm mt-3">Manage events, bookings and the programme.</p>

        <form onSubmit={submit} className="mt-10 space-y-4" data-testid="admin-login-form">
          <input
            type="email"
            required
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-transparent border-b border-soft py-3 text-sm focus:outline-none focus:border-charcoal"
            data-testid="admin-email"
          />
          <input
            type="password"
            required
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-transparent border-b border-soft py-3 text-sm focus:outline-none focus:border-charcoal"
            data-testid="admin-password"
          />
          {error && <div className="text-xs text-red-700" data-testid="admin-error">{error}</div>}
          <button disabled={submitting} className="btn-primary w-full justify-center mt-2" data-testid="admin-submit">
            {submitting ? "Signing in…" : "Sign in"}
          </button>
          <div className="text-xs mt-2 text-right">
            <Link to="/admin/forgot-password" className="link-hover" data-testid="admin-forgot-link">Forgot password?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
